/**
 * Onboarding Wizard Types
 */

export interface WizardStep {
  id: string;
  path: string;
  title: string;
  subtitle: string;
}

export interface DesignAsset {
  assetId: string;
  assetUrl: string;
  fileName: string;
}

export interface WizardData {
  // Step 1: Customer data
  customerEmail: string;
  customerName: string;
  notes: string;
  // Step 2: Shop basics
  shopName: string;
  language: string;
  subdomain: string;
  // Step 3: Collection
  collectionId: string;
  collectionName: string;
  // Step 4: Design (asset IDs after upload)
  frontDesign: DesignAsset | null;
  backDesign: DesignAsset | null;
  frontPlacement: string;
  backPlacement: string;
}

export interface PlacementOption {
  id: string;
  label: string;
  description: string;
  icon: string;
}

/**
 * Collection option for UI display
 * Maps API CollectionSummary to UI-friendly format
 */
export interface CollectionOption {
  id: string;
  title: string;
  description: string;
  image: string;
  products: string[];
  colors: string[];
  style: string;
}

export const INITIAL_WIZARD_DATA: WizardData = {
  customerEmail: '',
  customerName: '',
  notes: '',
  shopName: '',
  language: 'en',
  subdomain: '',
  frontDesign: null,
  backDesign: null,
  frontPlacement: '',
  backPlacement: '',
  collectionId: '',
  collectionName: '',
};
